import {
  buildXingshanAdvancedKeyCatalog,
  originalData,
  originalDataBeiying,
  originalDataHuafenda,
  resolveHuafendaAdvancedKeyCatalog,
  resolveRongyuanAdvancedKeyCatalog,
} from "../../../../../keyboard-management/src/pages/advancedKey/originalData";

/** 与子应用 advancedKey/Home.tsx 一致：按方案返回可选高级键类型卡片 */
export function getAdvancedKeyPreviewCatalog(
  solutionProvider?: string,
  equipment?: unknown
): typeof originalData {
  const provider = solutionProvider?.toLowerCase();
  if (provider === "beiying" || provider === "beiyingmachine") {
    return JSON.parse(JSON.stringify(originalDataBeiying));
  }
  if (provider === "huafenda") {
    if (equipment) {
      return resolveHuafendaAdvancedKeyCatalog(equipment);
    }
    return JSON.parse(JSON.stringify(originalDataHuafenda));
  }
  if (provider === "rongyuan") {
    return resolveRongyuanAdvancedKeyCatalog();
  }
  if (provider === "xingshan") {
    return buildXingshanAdvancedKeyCatalog();
  }
  return JSON.parse(JSON.stringify(originalData));
}

/** 与子应用 advancedKey/Home.tsx 一致：布局样式挂在 advancedKey-keyboard 上 */
export function resolveAdvancedKeyKeyboardClassName(
  _solutionProvider?: string
): string {
  return "advancedKey-keyboard";
}
